import { createAuth } from '@justgiving/auth';
import config from './config';

export const auth = createAuth({
  documentOrReq: document,
  authCookieName: config.authCookieName,
  activeGroupCookieName: config.activeGroupCookieName,
  refreshAccessTokenUrl: config.refreshAccessTokenApi,
});

export default auth;
